import styled, { css } from 'styled-components';

interface TableStylesProps {
  isViewMoreActive: boolean;
  borderRadius?: number;
  padding?: number;
  columnBorder?: boolean;
  smallWidth?: boolean;
  stickyFirstColumn?: boolean;
}

export const TableStyles = styled.div(
  ({
    isViewMoreActive,
    borderRadius = 12,
    padding = 16,
    columnBorder = false,
    smallWidth = false,
    stickyFirstColumn = false,
  }: TableStylesProps) => {
    const borderBottomRadius = isViewMoreActive ? 0 : borderRadius;
    const borderStyle = '0.45px solid #e1e5ee';
    return css`
      overflow-x: auto;
      table {
        width: ${smallWidth ? '70%' : '100%'};
        border-collapse: separate;
        border: ${borderStyle};

        @media (max-width: 768px) {
          width: 100%;
        }
        border-radius: ${borderRadius}px;
        border-bottom-right-radius: ${borderBottomRadius}px;
        border-bottom-left-radius: ${borderBottomRadius}px;
        tr {
          :last-child {
            td {
              border-bottom: 0;
            }
          }
        }
        th,
        td {
          margin: 0;
          padding: ${padding}px;
          border-bottom: ${borderStyle};
          border-right: ${columnBorder ? borderStyle : 'none'};

          :last-child {
            border-right: 0;
          }
        }
        th {
          background: #f6faff;
          font-weight: 600;
        }
        ${stickyFirstColumn
          ? `
          th:first-child,
          td:first-child {
            position: sticky;
            left: 0;
            z-index: 1;
          }
          th:first-child {
            background: #f6faff;
          }
          td:first-child {
            background: #ffffff;
          }
        `
          : ''}
      }

      button.viewMore {
        border: ${borderStyle};
        padding: ${padding}px;
        border-radius: ${borderRadius}px;
        border-top: none;
        border-top-right-radius: ${borderBottomRadius}px;
        border-top-left-radius: ${borderBottomRadius}px;
      }
    `;
  }
);
